import React, { MouseEvent } from 'react';
import { useMediaQuery } from 'common/hooks';
import { useShowEBoxLocationButton } from '../../hooks';

import { EBoxLocationTabletButton } from './EBoxLocationTabletButton/EBoxLocationTabletButton';
import { EBoxLocationMobileButton } from './EBoxLocationMobileButton/EBoxLocationMobileButton';

export const EBoxLocationButton = ({ onClick }: LocationButtonProps) => {
  const { isMobile } = useMediaQuery();
  const showEBoxLocationButton = useShowEBoxLocationButton();
  
  if (!showEBoxLocationButton) return null;
  if (isMobile) return <EBoxLocationMobileButton onClick={onClick} />;
  return <EBoxLocationTabletButton onClick={onClick} />;
};

export interface LocationButtonProps {
  onClick?: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
}
